import React from 'react';
import '@elastic/react-search-ui-views/lib/styles/styles.css';
import Template from './template';
import Router from './routes';

export default function App() {
  return (
    <div className='jobsearch__app'>
    <Template>
      <Router />
    </Template>
    </div>
  );
}
